/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { InsightValue_Output } from './InsightValue_Output';

export type RecordInsight = {
  record_id: number;
  type: RecordInsight.type;
  status: RecordInsight.status;
  value?: InsightValue_Output | null;
  language: RecordInsight.language;
};

export namespace RecordInsight {
  export enum type {
    TOC = 'toc',
    ACTION_ITEM = 'action_item',
    KEYWORD = 'keyword',
    DATE_TIME = 'date_time',
    SUMMARY = 'summary',
    TAKEAWAY = 'takeaway',
    ACTION_ITEM_TS = 'action_item_ts',
  }

  export enum status {
    CREATED = 'created',
    PROCESSED = 'processed',
    FAILED = 'failed',
    NOT_SUPPORTED = 'not_supported',
  }

  export enum language {
    KO = 'ko',
    EN = 'en',
    JA = 'ja',
    ZH = 'zh',
    ES = 'es',
    FR = 'fr',
    DE = 'de',
    IT = 'it',
    PT = 'pt',
    RU = 'ru',
    NL = 'nl',
    AR = 'ar',
    HI = 'hi',
    VI = 'vi',
    TH = 'th',
    ID = 'id',
  }
}
